import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import { TASKBAR_HEIGHT } from '@/constants';

const TaskbarRoot = styled(Box)(({ theme }) => ({
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  height: TASKBAR_HEIGHT,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(0, 1.5),
  backgroundColor: theme.palette.background.paper,
  borderTop: `2px solid ${theme.palette.divider}`,
  boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.05)',
  fontSize: '0.7rem',
  zIndex: 25,
}));

const TaskSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  color: theme.palette.text.secondary,
}));

function clamp(value: number, min: number, max: number) {
  return Math.min(max, Math.max(min, value));
}

export function Taskbar() {
  const [time, setTime] = useState('');
  const [cpu, setCpu] = useState(12);
  const [mem, setMem] = useState(640); // K

  /* Clock */
  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      setTime(
        now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
      );
    };

    updateTime();
    const interval = setInterval(updateTime, 1000);
    return () => clearInterval(interval);
  }, []);

  /* CPU + MEM drift */
  useEffect(() => {
    let cpuTimeout: number;
    let memTimeout: number;

    const tickCpu = () => {
      setCpu((prev) => clamp(prev + (Math.random() > 0.5 ? 1 : -1), 8, 18));

      cpuTimeout = window.setTimeout(tickCpu, 3000 + Math.random() * 3000);
    };

    const tickMem = () => {
      setMem((prev) => clamp(prev + (Math.random() > 0.5 ? 8 : -8), 600, 680));

      memTimeout = window.setTimeout(tickMem, 5000 + Math.random() * 4000);
    };

    tickCpu();
    tickMem();

    return () => {
      clearTimeout(cpuTimeout);
      clearTimeout(memTimeout);
    };
  }, []);

  return (
    <TaskbarRoot>
      <TaskSection sx={{ ml: 2 }}>
        <Typography variant="caption">CPU: {cpu}%</Typography>
        <Typography variant="caption">MEM: {mem}K</Typography>
        <Typography variant="caption">NET: OK</Typography>
      </TaskSection>

      <TaskSection sx={{ mr: 2 }}>
        <Typography variant="caption">{time}</Typography>
      </TaskSection>
    </TaskbarRoot>
  );
}
